import { Document } from '../../jurisdiction/jurisdiction.domain';

export class DocumentAndInputName {
  constructor(document: Document, inputName?: string) {
    this.document = document;
    this.inputName = inputName;
  }
  document: Document;
  inputName: string;
}
